angular.module('jv.common.currency.applyfield.directive',[])
.directive('jvCurrencyApplyField', ['$timeout',
    function($timeout){
        var currencySelectControl = '<div class="jv-button">{{currencyCode.codeWithSymbol}} <i class="icon icon-arrow-down jv-text-icon"></i><select class="currency" name="input" ng-model="code" ng-options="o as o.displayName for (k,o) in currencyMap" ng-required="field.required" aria-required="{{ field.required }}" ng-change="selectCurrencyCode()"></select></div>';
        var currencyInputControl =  '<input name="input" cleave="cleaveNum" ng-model="numberFormatter" ng-required="field.required" aria-required="{{ field.required }}" type="text" on-value-change="cleaveValueChanged" ng-disabled="currencyDisabled" maxlength="{{ maxNumLength }}" ng-style="inputElementStyle" placeholder="{{field.placeholder}}" />';
        var PLACEHOLDER = '——';
        return {
            restrict: 'AE',
            require: 'ngModel',
            template: '<div class="cws-currency-control">' + currencySelectControl + currencyInputControl + '</div>',
            scope: {
                ngModel: '=',
                field: '=jvCurrencyApplyField',
                cleaveNum:'=jvCurrencyCleave',
                maxNumLength: '@maxlength',
                placeholder: '@placeholder'
            },
            link: function(scope, el, attrs, ngModel) {
                scope.currencyCode = {
                    codeWithSymbol: PLACEHOLDER
                };
                scope.currencyDisabled = angular.isDefined(attrs.disabled);
                scope.fieldElement = el;
                var prepareMap = function(currencyCollection){
                    var currencyMap = {};
                    angular.forEach(currencyCollection, function(currency){
                        var currencyObj = JSON.parse(currency.value);
                        currencyMap[currencyObj.displayName] = currencyObj;
                    });
                    return currencyMap;
                };

                scope.currencyMap = prepareMap(scope.field.values);
                scope.field.placeholder = scope.placeholder || '';
                if(angular.isDefined(scope.field) && angular.isDefined(attrs.disabled)){
                    scope.field.required =  false;
                }
                scope.cleaveValueChanged = function(val) {
                    $timeout(function() {
                        if (!ngModel.$viewValue.value) {
                            return;
                        }
                        // ngModel always uses '.' for decimal mark regardless of localization setting
                        var numeralDecimalMark = '.';
                        var parts = ngModel.$viewValue.value.split(numeralDecimalMark);
                        var integers = parts[0];
                        var decimals = (parts[1] ? numeralDecimalMark + parts[1] : '');
                        if (integers.length > scope.cleaveNum.maxIntegers) {
                            scope.numberFormatter = integers.substring(0, scope.cleaveNum.maxIntegers) + decimals;
                        }
                    });
                };
                scope.$watch('currencyCode', function(newVal, oldVal) {
                    if (oldVal === newVal) {
                        return;
                    }
                    if(angular.isObject(newVal)){
                        if (ngModel.$viewValue) {
                            var k = ngModel.$viewValue;
                            k.currencyCode = newVal.currencyCode;
                            ngModel.$setViewValue(k);
                        } else {
                            ngModel.$setViewValue({
                                currencyCode: newVal.currencyCode
                            });
                        }
                        // SetTimeout to run the digest cycle again after current digest cycle
                        $timeout(function(){
                            scope.$apply();
                        });
                    }
                });
                scope.$watch('numberFormatter', function(newVal, oldVal) {
                    if (oldVal === newVal) {
                        return;
                    }
                    if (ngModel.$viewValue) {
                        var j = ngModel.$viewValue;
                        j.value = newVal;
                        ngModel.$setViewValue(j);
                    } else {
                        ngModel.$setViewValue({
                            value: newVal
                        });
                    }
                    // SetTimeout to run the digest cycle again after current digest cycle
                    $timeout(function(){
                        scope.$apply();
                    });
                });
                scope.selectCurrencyCode = function(){
                    scope.currencyCode = angular.copy(scope.code);
                    scope.code = '\n';
                    $timeout(function(){
                        scope.inputElementStyle = {
                            'padding-left': (scope.fieldElement.find('select')[0].offsetWidth + 10) + 'px'
                        };
                    });
                };
            }
        };
    }
]);
